import * as types from "./actions";
import APIUtil from "../config/APIUtil";
import UrlConstants from "../config/UrlConstants";
import * as code from "../config/Constants";
import { cryptoTokenDecode } from "../components/Common/Common";

/**
 *
 * @desc List Buyer Agents Matser template API call
 */
export function getBuyerAgentMasterTemplateAction(id) {
  let userType = cryptoTokenDecode().usertype;
  // console.log("userType13", userType);
  let url;
  if (userType === "VENDOR") {
    let ownerId = localStorage.getItem("ownerId");
    url = UrlConstants.buyerAgentMasterTemplate + "?" + "ownerId=" + ownerId;
  } else {
    url = UrlConstants.buyerAgentMasterTemplate + (id || "");
  }
  return function(dispatch) {
    return APIUtil.getMethod(url,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BUYER_GET_MASTER_TEMPLATE_DATA,
          buyerMasterTemplates: response.data.data,
          totalBuyerTemplates: response.data.total,
        });
      } else {
        dispatch({
          type: types.BUYER_GET_MASTER_TEMPLATE_DATA,
          buyerMasterTemplates: {},
          totalBuyerTemplates: 0,
        });
      }
    });
  };
}
/**
 *
 * @desc Update master template data API call
 */
export function updateTaskAction(
  data,
  model,
  campaignId,
  eventTempId,
  commuId,
  type
) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.buyerAgentMasterTemplate + "?id=" + eventTempId + model,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BUYER_UPDATE_MASTER_TEMPLATE_DATA,
          isMasterTemplateUpdatedBuyer: true,
          updatedEventDataBuyer: response.data,
        });
        return response.data;
      } else {
        dispatch({
          type: types.BUYER_UPDATE_MASTER_TEMPLATE_DATA,
          isMasterTemplateUpdatedBuyer: false,
          updatedEventDataBuyer: [],
        });
        return response.data;
      }
    });
  };
}

/**
 *
 * @desc Create New Campaign data API call
 */
export function createCampaignAction(data) {
  let userType = cryptoTokenDecode().usertype;
  if (userType === "VENDOR") {
    data.ownerId = localStorage.getItem("ownerId");
  }
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.buyerAgentMasterTemplate + "?model=campaign",
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BUYER_CREATE_MASTER_TEMPLATE,
          newCampaign: response.data,
        });
      } else {
        dispatch({
          type: types.BUYER_CREATE_MASTER_TEMPLATE,
          newCampaign: {},
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Update master template data API call
 */
export function createTaskAction(data) {
  let userType = cryptoTokenDecode().usertype;
  let url;
  if (userType === "VENDOR") {
    data.ownerId = localStorage.getItem("ownerId");
  }
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.buyerAgentMasterTemplate,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BUYER_CREATE_TASK,
          isEventCommCreated: true,
          addedEventComm: response.data,
        });
      } else {
        dispatch({
          type: types.BUYER_CREATE_TASK,
          isEventCommCreated: false,
          addedEventComm: [],
        });
      }

      return response.data;
    });
  };
}

/**
 *
 * @desc Get list of variables
 */
export function adminGetVarriableRefAction() {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.AdminGetVarriableRefMaterTemplateUrl,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.MASTER_TEMPLATE_GET_ALL_VERIABLE_REF,
          variablesRefs: response.data,
        });
      } else {
        dispatch({
          type: types.MASTER_TEMPLATE_GET_ALL_VERIABLE_REF,
          variablesRefs: [],
        });
      }
    });
  };
}

/**
 *
 * @desc Delete Communication template
 */
export function deleteTaskAction(eventtemplateId) {
  return function(dispatch) {
    var url = UrlConstants.buyerAgentMasterTemplate + "?id=" + eventtemplateId;
    return APIUtil.deleteMethod(url, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BUYER_DELETE_TASK,
          isMasterTemplateTaskDeleted: true,
        });
      } else {
        dispatch({
          type: types.BUYER_DELETE_TASK,
          isMasterTemplateTaskDeleted: false,
        });
      }
    });
  };
}

/**
 *
 * @desc Get list of variables
 */
export function getTasksByCampaignIdAction(id) {
  let userType = cryptoTokenDecode().usertype;
  // console.log("userType14", userType);
  let url;
  if (userType === "VENDOR") {
    let ownerId = localStorage.getItem("ownerId");
    url =
      UrlConstants.buyerAgentMasterTemplate +
      "?campaign=" +
      id +
      "&ownerId=" +
      ownerId;
  } else {
    url = UrlConstants.buyerAgentMasterTemplate + "?campaign=" + id;
  }
  return function(dispatch) {
    return APIUtil.getMethod(url,
      true
    ).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.MASTER_TEMPLATE_GET_CAMPAIGN_DATA_BY_ID_BUYER,
            BuyerCampDataById: response.data.data,
          });
        } else {
          dispatch({
            type: types.MASTER_TEMPLATE_GET_CAMPAIGN_DATA_BY_ID_BUYER,
            BuyerCampDataById: [],
          });
        }
        return response.data;
      },
      (error) => {
        return error;
      }
    );
  };
}

/**
 *
 * @desc Create new trasaction API call
 */
export function createTransactionAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.AdminCreateTransactionUrl,
      data,
      true
    ).then((response) => {
      //console.log("createTransactionAction response", response);

      if (response.status === code.OK) {
        dispatch({
          type: types.CREATE_TRANSACTION,
          isTrascationCreated: true,
          createTransactionData: response.data,
        });
      } else {
        dispatch({
          type: types.CREATE_TRANSACTION,
          isTrascationCreated: false,
          createTransactionData: [],
        });
      }

      return response.data;
    });
  };
}

/**
 *
 * @desc Update dependent Task
 */
export function updateDependentTaskAction(
  data,
  model,
  campaignId,
  eventTempId,
  commuId,
  type
) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.updateBuyerDependentTaskURL + eventTempId,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BUYER_UPDATE_DEPENDENT_TASKS,
        });
        return response.data;
      } else {
        dispatch({
          type: types.BUYER_UPDATE_DEPENDENT_TASKS,
        });
        return response;
      }
    });
  };
}

/**
 *
 * @desc Delete Communication template
 */
export function removeDependencyAction(id, removeId) {
  return function(dispatch) {
    var url = UrlConstants.removeDependencyBuyer
      .replace("{id}", id)
      .replace("{removeId}", removeId);

    return APIUtil.deleteMethod(url, true).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.REMOVE_DEPENDENCY_BUYER,
        });
      } else {
        dispatch({
          type: types.REMOVE_DEPENDENCY_BUYER,
        });
      }
    });
  };
}

/**
 *
 * @desc Delete compaign from list
 */
export function deleteUserCampaignListAction(data) {
  let url = UrlConstants.deleteUserCampaignUrl + "/" + data.id;

  return function(dispatch) {
    return APIUtil.putMethod(url, data, true).then((response) => {
      dispatch({
        type: types.BUYER_GET_MASTER_TEMPLATE_DATA,
        buyerMasterTemplates:
          response.status === code.OK ? response.data.data : {},
        totalBuyerTemplates:
          response.status === code.OK ? response.data.total : 0,
      });
      return response;
    });
  };
}

/**
 *
 * @desc get user campaigns for default listing
 */
export function getUserCampaignsAction(id) {
  let url;
  if(id){
    url = UrlConstants.buyerAgentMasterTemplate + "/usermastercampaign?id=" + id;
  }
  else{
    url = UrlConstants.buyerAgentMasterTemplate + "/usermastercampaign";
  }

  return function(dispatch) {
    return APIUtil.getMethod(url,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.BUYER_GET_MASTER_TEMPLATE_DATA,
          buyerMasterTemplates: response.data.data,
        });
      } else {
        dispatch({
          type: types.BUYER_GET_MASTER_TEMPLATE_DATA,
          buyerMasterTemplates: {},
        });
      }
      return response;
    });
  };
}


/**
 *
 * @desc update default user campaign
 */
export function updateUserCampaignDefaultAction(data) {
  let url = UrlConstants.buyerAgentMasterTemplate + "/userdefaultcampaign";

  return function(dispatch) {
    return APIUtil.putMethod(url, data, true).then((response) => {
      dispatch({
        type: types.BUYER_GET_MASTER_TEMPLATE_DATA,
        buyerMasterTemplates:
          response.status === code.OK ? response.data.data : {},
      });
      return response;
    });
  };
}
